import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ExternalParameters } from 'src/app/models/external-parameters';
import { User } from 'src/app/models/user';
import { TokenStorage } from '../../core/token-storage';
import { ExternalsParametersService } from '../externals-parameters.service';
import { OrganizationsService } from '../organizations.service';
import { UsersService } from '../users.service';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationGuard {
    private CESAR_ACCESS_TOKEN = '__access_token__';
    private EXTERNAL_PARAMETER = 'parameters';

    constructor(
        private router: Router,
        private usersService: UsersService,
        private organizationsService: OrganizationsService,
        private tokenStorage: TokenStorage,
        private externalsParametersService: ExternalsParametersService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        var ssoToken = next.queryParams[this.CESAR_ACCESS_TOKEN];

        if (ssoToken) {
            // Initialise les éventuels données en session
            this.usersService.removeCurrentUser();

            // Verifie sur le serveur si le token est correct.
            return this.usersService.checkCurrentUser(ssoToken).pipe(
                map(
                    (x) => {
                        let currentUser = x;

                        if (currentUser) {
                            // Enregistre le token
                            this.tokenStorage.saveToken(ssoToken);

                            // Par défaut l'organisation en cours d'administration est celle de l'utilisateur connecté
                            this.organizationsService.getOrganisation(currentUser.organizationId).subscribe((x) => {
                                this.organizationsService.setCurrentOrganization(x);

                                const params = { ...next.queryParams };

                                if (params[this.EXTERNAL_PARAMETER]) {
                                    console.log(JSON.parse(params[this.EXTERNAL_PARAMETER]));
                                    this.externalsParametersService.loadExternalParameters(JSON.parse(params[this.EXTERNAL_PARAMETER]) as ExternalParameters);
                                }

                                // Supprime les paramètres
                                delete params[this.CESAR_ACCESS_TOKEN];
                                delete params[this.EXTERNAL_PARAMETER];

                                this.router.navigate([state.url.substring(0, state.url.indexOf('?'))], { queryParams: params });

                                return true;
                            });
                            return false;
                        } else {
                            this.router.navigate(['/login']);
                            return false;
                        }
                    },
                    () => {
                        this.router.navigate(['/login']);
                        return false;
                    }
                )
            );
        } else {
            let currentUser: User;

            return this.usersService.getSessionCurrentUser().pipe(
                map((x) => {
                    currentUser = x;

                    if (currentUser) {
                        return true;
                    } else {
                        // Initialise les éventuels données en session
                        this.usersService.removeCurrentUser();

                        this.router.navigate(['/login']);
                        return false;
                    }
                })
            );
        }
    }
}
